import Client from 'config/axios';

export const getCompanyDataById = async (token: string, companyId: number) => {
  return await Client.get(`company/${companyId}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.data)
    .catch(error => ({
      errors: error?.response?.data?.data
    }));
};

export const getCompanyDataBySubdomain = async (subdomain: string) => {
  return await Client.get(`get-company-styles-by-subdomain/${subdomain}`, {
    headers: { 'Content-type': 'application/json' }
  })
    .then(response => response.data.data)
    .catch(error => error);
};

export const getCompanyLogs = async (
  token: string,
  page: number,
  limit: number
) => {
  return await Client.get(`logs/${page}/${limit}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.data)
    .catch(error => ({
      errors: error?.response?.data?.data
    }));
};

export const getSearchCompanyLogs = async (
  token: string,
  page: number,
  limit: number,
  companyId?: number
) => {
  return await Client.get(`logs/${page}/${limit}/${companyId}`, {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.data)
    .catch(error => ({
      errors: error?.response?.data?.data
    }));
};
